export default "__VITE_ASSET__BH9K5Cnf__"